define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"./NewSalesOrderLineItem"
], function(declare,lang,NewSalesOrderLineItem) {

return declare(NewSalesOrderLineItem, {
		getFormData: function() {
			// summary: add hook into form data to determine if node is already selected
			var fd = this.inherited(arguments);
			fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
			return fd;
		},

		_isPreSelected: function(/*csi.def.Context*/ctx, /*csi.action.FormData*/fd) {
			// summary: determine if ColorMaterial.ColorSpecification is in aggregation list
			var salesOrder = this.getParent();
			return (salesOrder.ProductSKUs && salesOrder.ProductSKUs.indexOf(ctx.getNodeURL()) != -1) ||
				   (salesOrder.SKUs && salesOrder.SKUs.indexOf(ctx.getNodeURL()) != -1) ;
		}

	});
});
